module.exports = __webpack_public_path__ + "f8546ef5f62b4b43229afa8db6a96d28.svg";